(function () {
    "use strict";

    angular.module("app").directive('i18n', InternationalizationDirective);

    InternationalizationDirective.$inject = ['$filter'];
    function InternationalizationDirective($filter) {
        return {
            priority: 0,
            restrict: "A",
            link: function (_scope, elm, attrs) {
                const key = attrs.i18n;
                if (!key)
                    return "";

                const translation = $filter("habilTranslation")(key);
                
                elm.html(translation);
            }
        };
    }
})();